import { Component, Input, ViewChild } from '@angular/core';

import { Patient } from 'planner-shared';

import { PatientTasksComponent } from '../patient-tasks/patient-tasks.component';

@Component({
    selector: 'app-patient-info',
    templateUrl: './patient-info.component.html',
    standalone: false
})
export class PatientInfoComponent {
    @Input() public patient: Patient;

    @ViewChild(PatientTasksComponent) private readonly patientTasksComponent: PatientTasksComponent;

    constructor() {}

    public reloadPatientTasksFeasibilityInfo(patientId: string): void {
        this.patientTasksComponent.reloadTasksFeasibilityInfo(patientId);
    }

    public reloadPatientTasks(): void {
        this.patientTasksComponent.initTasks();
    }
}
